@if (!displayIcon) {
  <button
    [matMenuTriggerFor]="filterMenu"
    class="filter-menu-button"
    color="accent"
    mat-button
    type="button">
    FILTER
  </button>
}

@if (displayIcon) {
  <button
    [matMenuTriggerFor]="filterMenu"
    color="accent"
    mat-icon-button
    type="button">
    <mat-icon>filter_list</mat-icon>
  </button>
}

<mat-menu #filterMenu="matMenu"
  class="filter-menu"
  xPosition="before"
  yPosition="below">

  <div class="toolbar-header">
    <span class="title">Filter</span>
    <button (click)="onClearFilters()"
      class="clear-button"
      color="accent"
      mat-button>
      CLEAR
    </button>
  </div>

  @if (sortOptions && sortOptions.length > 0) {
    <buyiq-expansion-panel
      gcPreventMenuClose>
      <buyiq-expansion-panel-title class="section-heading">Sort Options</buyiq-expansion-panel-title>
      <buyiq-sort-menu (changeSortOption)="onChangeSortOption($event)"
        [clearSort]="clearSort"
        [defaultSortType]="defaultSortType"
        [sortOptions]="sortOptions">
      </buyiq-sort-menu>
    </buyiq-expansion-panel>
  }

  @if (filterGroups && filterGroups.length > 0) {
    <buyiq-expansion-panel
      [expanded]="!!openFilterGroup"
      gcPreventMenuClose>
      <buyiq-expansion-panel-title class="section-heading">Filters</buyiq-expansion-panel-title>
      @if (filterGroups.length > 1) {
        @for (group of filterGroups; track group) {
          <buyiq-expansion-panel [expanded]="group.id === openFilterGroup"
            [limitHeight]="true"
            gcPreventMenuClose>
            <buyiq-expansion-panel-title
            class="section-subheading">{{group.displayName}}</buyiq-expansion-panel-title>
            <mat-selection-list (selectionChange)="onChangeFilter($event, group.id)"
              color="accent">
              <cdk-virtual-scroll-viewport itemSize="48"
                minBufferPx="384"
                maxBufferPx="480"
                                                     [style]="{
                                                         'height': getFilterGroupScrollHeight(filters[group.id])+'px',
                                                     }">
                <mat-list-option
                  *cdkVirtualFor="let filter of filters[group.id]; trackBy: filterTrackBy"
                  [value]="filter.key"
                  [selected]="filter.isSelected">
                  {{ filter.description }}
                </mat-list-option>
              </cdk-virtual-scroll-viewport>
            </mat-selection-list>
          </buyiq-expansion-panel>
        }
      } @else {
        @for (group of filterGroups; track group) {
          <mat-selection-list (selectionChange)="onChangeFilter($event, group.id)"
            color="accent">
            @for (filter of filters[group.id]; track filterTrackBy($index, filter)) {
              <mat-list-option
                [selected]="filter.isSelected"
                [value]="filter.key">
                {{filter.description}}
              </mat-list-option>
            }
          </mat-selection-list>
        }
      }
    </buyiq-expansion-panel>
  }
</mat-menu>

